module.exports = __webpack_public_path__ + "dbb0995cc2e4b9ea795e767cbc1ec943.png";